/**
 * What: Shared runtime type guards for unknown JSON values.
 * Transport / data-flow: Pure functions with no I/O; safe for any package.
 *
 * Semantics are the canonical isRecord body (see #3150): plain objects and
 * class instances pass — there is intentionally no prototype check and arrays
 * are rejected. Callers needing stricter shapes (prototype-strict audit
 * events, array-accepting envelopes) keep their own local copies.
 */
export function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
//# sourceMappingURL=guards.js.map